/**
 * TMR API Auth HTTP Interceptor
 *
 * @alias TmrApiAuthInterceptor
 * @type {ngFactory}
 */
function TmrApiAuthInterceptorFactory(TmrLocalStorage, tmrApiAuthToken) {
  'ngInject'

  return {
    request,
  }

  /**
   * Adds the authentication token to requests made to the TMR API.
   */
  function request(config) {
    // Fill the authorization token key.
    if (config.headers[tmrApiAuthToken] === null) {
      config.headers[tmrApiAuthToken] = TmrLocalStorage.get('authToken')
        ? `Bearer ${TmrLocalStorage.get('authToken')}`
        : undefined
    }
    return config
  }
}

/**
 * Registers the {@link TmrApiAuthInterceptor TMR API Auth HTTP Interceptor}
 *
 * @type {ngConfig}
 */
let tmrUserAuthConfig = /*@ngInject*/ $httpProvider =>
  $httpProvider.interceptors.push('TmrApiAuthInterceptor')

export const factory = ['TmrApiAuthInterceptor', TmrApiAuthInterceptorFactory]
export { tmrUserAuthConfig as config }
